import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { OrderSuccessComponent } from './success/order-success.component';
import { MatIconModule } from '@angular/material/icon';
import { OrderFailedComponent } from './failed/order-failed.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from '../components/components.module';
import { PaymentOrderSuccessComponent } from './confirmation/payment-order-success.component';
import { OrderCallbackComponent } from './callback/order-callback.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { OrderComponent } from './order/order.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../common/shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PaymentAmountComponent } from './order/payment-amount/payment-amount.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes: Routes = [
  {
    path: '',
    component: OrderComponent,
    data: {
      title: 'Comanda',
      breadcrumb: 'Comanda',
      metaDescription: '',
    },
  },
  {
    path: 'success',
    component: OrderSuccessComponent,
    data: {
      title: 'Comandă plasată cu succes',
      breadcrumb: 'Comandă plasată',
      metaDescription: '',
    },
  },
  {
    path: 'confirmation',
    component: PaymentOrderSuccessComponent,
    data: {
      title: 'Confirmare comandă',
      breadcrumb: 'Confirmare comandă',
      metaDescription: '',
    },
  },
  {
    path: 'callback',
    component: OrderCallbackComponent,
  },
  {
    path: 'failed',
    component: OrderFailedComponent,
    data: {
      title: 'Plata eșuată',
      breadcrumb: 'Plata eșuată',
      metaDescription: '',
    },
  },
];
@NgModule({
  declarations: [
    OrderComponent,
    OrderSuccessComponent,
    OrderFailedComponent,
    PaymentOrderSuccessComponent,
    OrderCallbackComponent,
    PaymentAmountComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    RouterModule,
    ComponentsModule,
    NgxGoogleAnalyticsModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatCheckboxModule,
    FormsModule,
    SharedModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatExpansionModule,
    NgOptimizedImage,
    MatTooltipModule,
  ],
  exports: [OrderComponent],
})
export class OrdersModule {}
